module.exports = __webpack_public_path__ + "static/media/siddharth-bannerghatta-zoo-trip-14.7a5ba805.png";